import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'

import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa'
import { FaTiktok } from 'react-icons/fa6'

import footerLogo from "../../../assets/images/footerLogo.png"
import footerMark from "../../../assets/images/vucaLogo.svg"

const Footer = () => {
    return (
        <footer className="footer">

            {/* <img src={footerbg} alt="" className="footer-bg" /> */}
            <div className="footer-overlay"></div>

            <div className="footer-container">

                <div className="footer-top">
                    <img src={footerLogo} alt="logo" className="footer-logo" />

                    <div className="footer-right-top">
                        <p>All rights reserved</p>
                        <span>API © {new Date().getFullYear()}</span>
                    </div>
                </div>

                <div className="footer-line"></div>

                <div className="footer-content">

                    <div className="footer-links">
                        <h4>QUICK LINKS</h4>

                        <div className="links-grid">
                            <ul>
                                <li><Link to="/">HOME</Link></li>
                                <li><Link to="/about">ABOUT US</Link></li>
                                <li><Link to="/manufacture">MANUFACTURING LINES</Link></li>
                            </ul>

                            <ul>
                                <li><Link to="/partnership">PARTNERSHIP</Link></li>
                                <li><Link to="/contact">CONTACT</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer-socials">
                        <FaFacebookF />
                        <FaInstagram />
                        <FaTiktok />
                        <FaLinkedinIn />
                        <FaYoutube />
                    </div>

                </div>

                
            </div>

            <a href="https://vuca.li/" target='_blank'>
                <img src={footerMark} alt="" className="footer-mark" />
            </a>

        </footer>
    )
}

export default Footer